import { LEGEND_LIST } from './constants';
import * as S from './style';

export default function Legends() {
  return (
    <S.Wrapper>
      {LEGEND_LIST.map((item) => (
        <S.Legend key={`financial-chart-legend-${item.type}`} type={item.type}>
          {item.id}
        </S.Legend>
      ))}
    </S.Wrapper>
  );
}
